<div class="background mat-typography">
  <router-outlet />
</div>
